var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22.92 22.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{clip-rule:evenodd;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#212721;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(2.96 2.96)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.53,15.53l-4.14-4.07A6.66,6.66,0,0,0,12,2.29a7,7,0,0,0-9.72,0,6.66,6.66,0,0,0,0,9.54,7,7,0,0,0,9,.6l4.17,4.1a.55.55,0,0,0,.77,0l.25-.24a.54.54,0,0,0,0-.76M3.34,10.83a5.26,5.26,0,0,1,0-7.54,5.51,5.51,0,0,1,7.68,0,5.26,5.26,0,0,1,0,7.54,5.51,5.51,0,0,1-7.68,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(2.96 2.96)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -196.83,
    y: -155.57,
    width: 245.61,
    height: 445.37
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 22.92,
    height: 22.92
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.aeb7a291b901e13bc7dae1e57456af82.svg";
export { ForwardRef as ReactComponent };